/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer  } from 'recharts';

interface PropsType {
    dataset: any;
    labels: any;
    interval: number;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function LineChartComponent({ dataset, labels, interval }: PropsType): JSX.Element {

    const [lineProps, setLineProps] = useState<any>(
        labels.reduce(
          (a:any, { key }: any) => {
            a[key] = false;
            return a;
          },
          { hover: null }
        )
      );

      const selectLine = (e: any): void => {
        setLineProps({
          ...lineProps,
          [e.dataKey]: !lineProps[e.dataKey],
          hover: null
        });
      };

    return (
        <ResponsiveContainer width="100%" height="80%">
            <LineChart
                // width={500}
                // height={300}
                data={dataset}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" stroke="#3A3A3A" interval={interval <= 15 ? 0 : interval <= 30 ? 2 : 3} tickFormatter={(value, index) => (index === 0 && interval > 1 ? '' : value)}/>
                <YAxis stroke="#3A3A3A"  />
                <Tooltip />
                <Legend  onClick={selectLine} iconType='circle'/>
                {
                    labels.map((label: any) => (
                        <Line type="monotone" dataKey={label.key} name={label.label} stroke={label.color} hide={lineProps[label.key] === true} />
                    ))
                }
                
                
            </LineChart>
        </ResponsiveContainer>
    )
}

export default LineChartComponent